module.exports = __webpack_public_path__ + "media/images/cover/kitchen-1-6eb7244e1486293c1dc18fff2ee61234.jpg";